import { BaseRouteService } from "core/services";

class FacilityOrderTemplateValidationRouteService extends BaseRouteService {
	constructor() {
		super("facility-order-template-validations");	
	}
	
	find(filter) {
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,facilityOrderTemplateId}`, filter);
	}	

	bulkUpdate(resource) {
        return super.update(this.base + '/batch', resource);
    }

	resolve(resource) {
		return super.update(`${this.base}/{id}/resolve`, resource);
	}
}

export default FacilityOrderTemplateValidationRouteService;
